import React from 'react';
import styles from './ClientLogos.scss';
import Slider from "react-slick";
import img1 from './img/partners/client-alpha-gray.svg';
import img11 from './img/partners/client-alpha-color.svg';
import img2 from './img/partners/client-grant-gray.svg';
import img22 from './img/partners/client-grant-color.svg';
import img3 from './img/partners/client-absent-gray.webp';
import img33 from './img/partners/client-absent-color.webp';
import img4 from './img/partners/client-home-gray.svg';
import img44 from './img/partners/client-home-color.svg';
import img5 from './img/partners/client-joy-gray.svg';
import img55 from './img/partners/client-joy-color.svg';
import img6 from './img/partners/client-spoon-gray.webp';
import img66 from './img/partners/client-spoon-color.webp';
import {__t} from '../lang/text-resource';

const ClientLogos = () => {

	const settings = {
		slidesToShow: 10,
		slidesToScroll: 10,
		dots: false,
		arrows: false,
		autoplay: true,
		className: styles.slickSlider,
		infinite: true,
		variableWidth: false,
		pauseOnHover: true,
		autoplaySpeed: 3000,
		onInit: () => {
			// setSliderInitialized(true);
		},
		responsive: [
			{
				breakpoint: 2000,
				settings: {
					slidesToShow: 8,
					slidesToScroll: 8
				}
			},
			{
				breakpoint: 1600,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 6
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 5
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 460,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	};

	const partners = [
		<div key={"feature_1"} className={styles.feature}>
			<img src={img1} alt={__t("JOY")}/>
			<img src={img11} alt={__t("JOY")}/>
		</div>,
		<div key={"feature_2"} className={styles.feature}>
			<img src={img2} alt={__t("HOME2U")}/>
			<img src={img22} alt={__t("HOME2U")}/>
		</div>,
		<div key={"feature_3"} className={styles.feature}>
			<img src={img3} alt={__t("ALPHABEST")}/>
			<img src={img33} alt={__t("ALPHABEST")}/>
		</div>,
		<div key={"feature_4"} className={styles.feature}>
			<img src={img4} alt={__t("GrandOptics")}/>
			<img src={img44} alt={__t("GrandOptics")}/>
		</div>,
		<div key={"feature_5"} className={styles.feature}>
			<img src={img5} alt={__t("AbsentStudio")}/>
			<img src={img55} alt={__t("AbsentStudio")}/>
		</div>,
		<div key={"feature_6"} className={styles.feature}>
			<img src={img6} alt={__t("WoodenSpoon")}/>
			<img src={img66} alt={__t("WoodenSpoon")}/>
		</div>,
	];

	const sliderMode = window.innerWidth <= 1600;

	const getSlider = () => {
		let randomPartners = partners
		  .map(value => ({value, sort: Math.random()}))
		  .sort((a, b) => a.sort - b.sort)
		  .map(({value}) => value);

		return (
		  <Slider {...settings}>
			  {randomPartners}
		  </Slider>
		)
	};

	const getPartners = () => {
		let randomPartners = partners
		  .map(value => ({value, sort: Math.random()}))
		  .sort((a, b) => a.sort - b.sort)
		  .map(({value}) => value);

		return (
		  <>
			  {randomPartners}
		  </>
		)
	};

	return (
	  <div id="js-header-features-container" className={styles.featuresContainerOuter}>
		  <div id={"js-header-features"} className={styles.featuresContainer}>
			  {sliderMode ? getSlider() : getPartners()}
		  </div>
	  </div>
	);
};

ClientLogos.propTypes = {};

export default ClientLogos;